import React from "react";
import userImage from "../../../assets/user-img-placeholder.jpg";
import StarRating from "../../../components/StarRating";
function BDReview({ bookingDetails }) {
  return (
    <div>
      <>
        <div className="booking-detail-order-section">
          <div className="booking-detail-order-body">
            <div className="d-flex ce-info-section">
              <img
                src={
                  bookingDetails?.profile_picture
                    ? bookingDetails?.profile_picture
                    : userImage
                }
                width={45}
                height={45}
                alt="profile"
              />
              <div className="d-flex flex-column">
                <div className="d-flex align-items-center gap-2 ce-info-name-container">
                  <p className="ce-info-name mb-0">
                    {bookingDetails?.first_name} {bookingDetails?.last_name}
                  </p>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="2"
                    height="18"
                    viewBox="0 0 2 18"
                    fill="none"
                  >
                    <path
                      d="M0.523438 1.37646L0.523437 17.3765"
                      stroke="#E1E1E1"
                      stroke-linecap="round"
                    />
                  </svg>
                  <StarRating
                    rating={bookingDetails?.customerReview?.rating_stars}
                  />
                </div>
                <p className="ce-info-experience">
                  {bookingDetails?.customerReview?.review_message}
                </p>
              </div>
            </div>
            {bookingDetails?.customerReview?.review_images?.length > 0 && (
              <div className="ce-info-images">
                {bookingDetails?.customerReview?.review_images?.map(
                  (res, id) => (
                    <img
                      src={res?.file_path}
                      width={119}
                      style={{
                        objectFit: "cover",
                      }}
                      height={84}
                      key={id}
                      alt="customer"
                    />
                  )
                )}
              </div>
            )}
          </div>
        </div>
      </>
    </div>
  );
}

export default BDReview;
